export default {
  styleOverrides: {
    dense: {
      height: "60px",
      minHeight: "60px",
      fontSize: "18px",
    },
  },
};
